import { ValidationModel, ValidationType } from "@/services/validation/types";
import { Vue } from "vue-property-decorator";

export const settingsValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    width: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.NonNegativeNumber }
        ]
    } as ValidationModel,
    height: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.NonNegativeNumber }
        ]
    } as ValidationModel
};

// content validator helper methods

export function addContentValidators(validators: any, id: string) {
    Vue.set(validators,
        `layer-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
    Vue.set(validators,
        `x-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
    Vue.set(validators,
        `y-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
}

export function removeContentValidators(validators: any, id: string) {
    Vue.delete(validators,
        `layer-${id}`);
    Vue.delete(validators,
        `x-${id}`);
    Vue.delete(validators,
        `y-${id}`);
}

// zones validator helper methods

export function addZoneValidators(validators: any, id: string) {
    Vue.set(validators,
        `name-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
    Vue.set(validators,
        `width-${id}`,
        { rules: [{ type: ValidationType.Required }, { type: ValidationType.NonNegativeNumber }] } as ValidationModel);
    Vue.set(validators,
        `height-${id}`,
        { rules: [{ type: ValidationType.Required }, { type: ValidationType.NonNegativeNumber }] } as ValidationModel);
    Vue.set(validators,
        `x-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
    Vue.set(validators,
        `y-${id}`,
        { rules: [{ type: ValidationType.Required }] } as ValidationModel);
}

export function removeZoneValidators(validators: any, id: string) {
    Vue.delete(validators,
        `name-${id}`);
    Vue.delete(validators,
        `width-${id}`);
    Vue.delete(validators,
        `height-${id}`);
    Vue.delete(validators,
        `x-${id}`);
    Vue.delete(validators,
        `y-${id}`);
}
